import React, { useState } from 'react';
import Modal from 'react-modal';
import AssignmentDocument from './AssignmentDocument';
import PowerOfAttorneyDocument from './PowerOfAttorneyDocument';
import ReceiptDocument from './ReceiptDocument';
import { displayValue, getAssignorDocument, getIntermediaryName } from './documentHelpers';
import './IntermediaryDocumentModal.css';

const documentTabs = [
    'Cessão',
    'Procuração',
    'Recibo',
];

export default function IntermediaryDocumentModal({ acquisition, onClose }) {
    const [activeTab, setActiveTab] = useState(documentTabs[0]);

    if (!acquisition) {
        return null;
    }

    Modal.setAppElement('#root');

    const assignorDocument = getAssignorDocument(acquisition);
    const handlePrint = () => {
        const paper = window.document.querySelector('.intermediary-document-paper');
        const printWindow = window.open('', '_blank');

        if (!paper || !printWindow) {
            return;
        }

        printWindow.document.write(`
            <!doctype html>
            <html>
                <head>
                    <meta charset="utf-8" />
                    <title>${activeTab} - Intermediação #${acquisition.id}</title>
                    <style>
                        @page {
                            size: A4;
                            margin: 18mm 16mm;
                        }

                        * {
                            box-sizing: border-box;
                        }

                        body {
                            margin: 0;
                            color: #000000;
                            font-family: Arial, sans-serif;
                            font-size: 11pt;
                            line-height: 1.55;
                        }

                        p {
                            margin: 0 0 12px;
                            orphans: 3;
                            widows: 3;
                        }

                        table {
                            width: 100%;
                            border-collapse: collapse;
                            page-break-inside: auto;
                        }

                        tr {
                            page-break-inside: avoid;
                            page-break-after: auto;
                        }

                        th,
                        td {
                            padding: 6px;
                            border: 1px solid #000000;
                        }

                        .intermediary-document-paper {
                            width: 100%;
                            margin: 0;
                            padding: 0;
                            border: 0;
                            color: #000000;
                            text-align: justify;
                        }

                        .intermediary-document-title {
                            text-align: center;
                        }

                        .intermediary-document-receipt-quotas p {
                            margin-bottom: 4px;
                        }

                        .intermediary-document-quota-line {
                            display: grid;
                            grid-template-columns: 30mm 30mm 42mm;
                            column-gap: 3mm;
                            margin: 0 0 2mm;
                            line-height: 1.35;
                            text-align: left;
                        }

                        .intermediary-document-quota-line span {
                            white-space: nowrap;
                        }
                    </style>
                </head>
                <body>
                    ${paper.outerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };

    return (
        <Modal
            isOpen={Boolean(acquisition)}
            onRequestClose={onClose}
            contentLabel="Documento da intermediação"
            className="intermediary-document-modal"
            shouldCloseOnOverlayClick={true}
            style={{
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1000,
                },
                content: {
                    zIndex: 1001,
                },
            }}
        >
            <div className='intermediary-document-header'>
                <div>
                    <span>Intermediação #{acquisition.id}</span>
                    <h2>{displayValue(getIntermediaryName(acquisition))}</h2>
                </div>
                <button type='button' onClick={onClose}>X</button>
            </div>

            <div className='intermediary-document-body'>
                <div className='intermediary-document-toolbar'>
                    <div className='intermediary-document-tabs'>
                        {documentTabs.map((tab) => (
                            <button
                                key={tab}
                                type='button'
                                className={activeTab === tab ? 'active' : ''}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                    <button
                        type='button'
                        className='intermediary-document-print-button'
                        onClick={handlePrint}
                    >
                        Imprimir
                    </button>
                </div>

                {activeTab === 'Procuração' && (
                    <PowerOfAttorneyDocument acquisition={acquisition} document={assignorDocument} />
                )}
                {activeTab === 'Recibo' && (
                    <ReceiptDocument acquisition={acquisition} />
                )}
                {activeTab === 'Cessão' && (
                    <AssignmentDocument acquisition={acquisition} />
                )}
            </div>
        </Modal>
    );
}
